import { request } from './common';

export type Category2QueryRow = {
  queryText: string;
  spaceCount: number;
  searchCount: number;
  uniqueSearcherCount: number;
  matchedType: string | null;
  matchedName: string | null;
  isExactMatch: boolean;
};

export type Category2QueriesResponse = {
  status: number;
  result: Array<Category2QueryRow>;
  meta: {
    limit: number;
    offset: number;
    windowDays: number;
  };
};

export type Category2QueriesParams = {
  limit?: number;
  offset?: number;
};

export type Category3QueryRow = {
  queryText: string;
  spaceCount: number;
  searchCount: number;
  uniqueSearcherCount: number;
  matchedType: string | null;
  matchedName: string | null;
  isNameMatch: boolean;
  categoryReason: string;
};

export type Category3QueriesResponse = {
  status: number;
  result: Array<Category3QueryRow>;
  meta: {
    limit: number;
    offset: number;
    windowDays: number;
  };
};

export type Category3QueriesParams = {
  limit?: number;
  offset?: number;
};

async function getCategory2Queries(params: Category2QueriesParams = {}): Promise<Category2QueriesResponse> {
  const searchParams = new URLSearchParams();

  if (params.limit != null) {
    searchParams.set('limit', String(params.limit));
  }
  if (params.offset != null) {
    searchParams.set('offset', String(params.offset));
  }

  const queryString = searchParams.toString();

  return request(`/api/nls-analytics/category-2-queries${queryString ? `?${queryString}` : ''}`);
}

async function getCategory3Queries(params: Category3QueriesParams = {}): Promise<Category3QueriesResponse> {
  const searchParams = new URLSearchParams();

  if (params.limit != null) {
    searchParams.set('limit', String(params.limit));
  }
  if (params.offset != null) {
    searchParams.set('offset', String(params.offset));
  }

  const queryString = searchParams.toString();

  return request(`/api/nls-analytics/category-3-queries${queryString ? `?${queryString}` : ''}`);
}

const NlsAnalyticsService = {
  getCategory2Queries,
  getCategory3Queries,
};

export default NlsAnalyticsService;
